export default __webpack_public_path__ + "static/media/accounting_point_7.f30aa45b.png";